import { render, staticRenderFns } from "./RiskDashboard.vue?vue&type=template&id=2ab4774e"
import script from "./RiskDashboard.vue?vue&type=script&lang=js"
export * from "./RiskDashboard.vue?vue&type=script&lang=js"
import style0 from "./RiskDashboard.vue?vue&type=style&index=0&id=2ab4774e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports